export default __webpack_public_path__ + "static/media/Risk_Disclosure.d76dde67.pdf";